import { apiFetch } from "@/utils";
import store from "@/store/store"
import { getCurrentModuleUrl } from ".";


// Récupération des données de monitoring
function totp() {
  return apiFetch("auth/totp");
}

// Génère une nouvelle clé et revoque l'ancienne
function generateKey() {
  return apiFetch("auth/secretkey");
}

// Verifie le code saisi
function verifyCode(code, moduleUrl = "") {
  return new Promise((resolve, reject) => {
    if (!moduleUrl) moduleUrl = getCurrentModuleUrl();
    apiFetch("auth/totp/verify?code=" + code + "&moduleUrl=" + moduleUrl).then(res => {
      if (res) {// Un nouveau token double authentifié est généré
        store.commit("updateSelf", { token: res, TOTPVerified: true, TOTPVerifiedModuleUrl: moduleUrl })
        window.localStorage.setItem("jwt", res);
      }
      resolve(res ? true : false)
    }).catch(e => reject(e))
  });
}

export default { totp, generateKey, verifyCode }
export { totp, generateKey, verifyCode }



// WEBPACK FOOTER //
// ./src/utils/mfa.js